import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { getOrdersListing } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

export function OrdersListing() {

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    const timezone = localStorage.getItem('timezone');
    const statusSelectRef = useRef(null);
    const typeSelectRef = useRef(null);
    const sideSelectRef = useRef(null);
    const initialized = useRef(false); // Prevents multiple initializations

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [filters, setFilters] = useState({ order_status: 'all', order_type: 'all', order_side: 'all' });

    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            
            const userReq = {
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder,
                status: filters.order_status,
                order_type: filters.order_type,
                side: filters.order_side
            }
            console.log("REQUEST : ", userReq);
            const response = await getOrdersListing(userReq);
            if (parseInt(response.code) === 1) {
                setData(response.data.items);
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading orders, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();  // ✅ Ensure fetching happens when dependencies change
    }, [pagination, search, sortField, sortOrder]);

    // ✅ Trigger `fetchData()` when `filters` change
    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
    
            // Delay to allow React to fully render the select options before initializing select2
            setTimeout(() => {
                $(statusSelectRef.current).select2();
                $(typeSelectRef.current).select2();
                $(sideSelectRef.current).select2();
    
                // Trigger initial value set
                $(statusSelectRef.current).val(filters.order_status).trigger('change');
                $(typeSelectRef.current).val(filters.order_type).trigger('change');
                $(sideSelectRef.current).val(filters.order_side).trigger('change');
    
                // Set up change handler
                $(statusSelectRef.current).on("change", function () {
                    const value = $(this).val();
                    setFilters(prev => ({ ...prev, order_status: value }));
                });
                $(typeSelectRef.current).on("change", function () {
                    const value = $(this).val();
                    setFilters(prev => ({ ...prev, order_type: value }));
                });
                $(sideSelectRef.current).on("change", function () {
                    const value = $(this).val();
                    setFilters(prev => ({ ...prev, order_side: value }));
                });
            }, 1000);
        }
        fetchData(filters); // Fetch data after filters update
    }, [filters]);

    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
      // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const formatNumber = (num) => {
        if (!num) return "0";

        const parsed = parseFloat(num);
        return parsed % 1 === 0 
            ? parsed.toFixed(0) 
            : parsed.toFixed(2).replace(/\.?0+$/, "");
    };

    const handleClearFilter = () => {

        setFilters({ order_status: 'all', order_type: 'all', order_side: 'all' });
        // Trigger initial value set
        $(statusSelectRef.current).val('all').trigger('change');
        $(typeSelectRef.current).val('all').trigger('change');
        $(sideSelectRef.current).val('all').trigger('change');
    }

    const handleRefresh = () => {
        fetchData();
    }

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Orders Listing</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Orders Listing</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="table-responsive">
                                        <div className="toolbar">
                                            <div className="row" style={{ marginRight: '0px' }}>
                                                <div className="col-md-2 col-lg-2 col-xl-2">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <select ref={statusSelectRef} className="form-control" id="order_status" name="order_status" style={{ minWidth: '200px' }}>
                                                            <option value="all">All</option>
                                                            <option value="WORKING">Working</option>
                                                            <option value="ACCEPTED">Accepted</option>
                                                            <option value="OPEN_POSITION">Open Position</option>
                                                            <option value="CLOSE_POSITION">Closed Position</option>
                                                            <option value="CANCELED">Canceled</option>
                                                            <option value="REJECTED">Rejected</option>
                                                            <option value="EXPIRED">Expired</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 col-lg-2 col-xl-2">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <select ref={typeSelectRef} className="form-control" id="order_type" name="order_type" style={{ minWidth: '200px' }}>
                                                            <option value="all">All</option>
                                                            <option value="MARKET">Market</option>
                                                            <option value="LIMIT">Limit</option>
                                                            <option value="STOP">Stop</option>
                                                            <option value="OCO">OCO</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 col-lg-2 col-xl-2">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <select ref={sideSelectRef} className="form-control" id="order_side" name="order_side" style={{ minWidth: '200px' }}>
                                                            <option value="all">All</option>
                                                            <option value="BUY">Buy</option>
                                                            <option value="SELL">Sell</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <button type="button" onClick={handleClearFilter} className="btn btn-raised btn-primary btn-xs waves-effect m-t-25 ml-3">
                                                        CLEAR
                                                    </button>&nbsp;
                                                    <button type="button" onClick={handleRefresh} className="btn btn-raised bg-primary btn-xs waves-effect m-t-25 ml-3">
                                                        <i class="zmdi zmdi-refresh-sync"></i>
                                                    </button>
                                                </div>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <input
                                                            type="text"
                                                            placeholder="🔍 Search..."
                                                            value={search}
                                                            onChange={(e) => setSearch(e.target.value)}
                                                            style={{
                                                                width: "100%",
                                                                padding: "10px 15px",
                                                                borderRadius: "25px",
                                                                border: "1px solid #ccc",
                                                                outline: "none",
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                fontSize: "14px",
                                                            }}
                                                            className="form-control mb-3"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <DataTable
                                            columns={[
                                                
                                                { name: "GROUP-ORDER-ID", selector: (row) => row.group_order_id, sortable: true, width: '18%' },
                                                { name: "USER NAME", selector: (row) => `${row.first_name} ${row.last_name}`, sortable: true, sortableField: "first_name", width: '12%' },
                                                { name: "TYPE", selector: (row) => {
                                                    if (row.type === 'MARKET') {
                                                        return <label className="label label-success label-xs">{row.type}</label>
                                                    } else if (row.type === 'STOP' || row.type === 'LIMIT') {
                                                        return <label className="label label-danger label-xs">{row.type}</label>
                                                    } else {
                                                        return <label className="label label-warning label-xs">{row.type}</label>
                                                    }
                                                }, sortable: false, width: '8%' },
                                                { name: "SIDE", selector: (row) => {
                                                    return (row.side === 'BUY') ? <label className="label label-success label-xs">{row.side}</label> : <label className="label label-warning label-xs">{row.side}</label>;
                                                }, sortable: false, width: '6%' },
                                                { name: "QTY", selector: (row) => row.quantity, sortable: true, sortableField: "quantity", width: '6%' },
                                                { name: "SYMBOL", selector: (row) => row.symbol, sortable: false, width: '8%' },
                                                { name: "LIMIT-PRICE", selector: (row) => `${formatNumber(row.limit_price)} ${row.user_currency}`, sortable: false, width: '9%' },
                                                { name: "STOP-PRICE", selector: (row) => `${formatNumber(row.stop_price)} ${row.user_currency}`, sortable: false, width: '9%' },
                                                { name: "STATUS", selector: (row) => {
                                                    if (row.status === 'WORKING' || row.status === 'ACCEPTED') {
                                                        return <label class="label label-warning">{row.status}</label>
                                                    } else if (row.status === 'COMPLETED') {
                                                        return <label class="label label-success">{row.status}</label>
                                                    } else {
                                                        return <label class="label label-danger">{row.status}</label>
                                                    }
                                                }, sortable: false, width: '10%' },
                                                { name: "TP/SL", selector: (row) => {
                                                    if (row.is_take_profit_enabled === 'Yes' && row.is_stop_loss_enabled === 'Yes') {
                                                        return <><label class="label label-success">TP</label>&nbsp;<label class="label label-danger">SL</label></>
                                                    } else if (row.is_take_profit_enabled === 'Yes' && row.is_stop_loss_enabled === 'No') {
                                                        return <><label class="label label-success">TP</label></>
                                                    } else if (row.is_take_profit_enabled === 'No' && row.is_stop_loss_enabled === 'Yes') {
                                                        return <><label class="label label-danger">SL</label></>
                                                    } else {
                                                        return <><label class="label label-black">NA</label></>
                                                    }
                                                }, sortable: false, width: '8%' },
                                                { name: "CREATED AT", selector: (row) => convertUTCToLocal(row.created_at, timezone), sortable: true, sortableField: "created_at", width: '15%' },
                                                { 
                                                    name: "ACTIONS", 
                                                    selector: (row) => (
                                                        <>
                                                            <a
                                                                href={ `/authpanel/orders/view/${btoa(row.order_id)}` }
                                                                className="btn btn-xs waves-effect waves-float waves-green"
                                                                style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                            >
                                                                <i className="zmdi zmdi-eye" style={{ color: '#D7C9A1' }} />
                                                            </a>
                                                        </>
                                                    ),
                                                    sortable: false,
                                                    width: '7%'
                                                },
                                            ]}
                                            data={data || []}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            paginationPerPage={50} // Default page size
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onSort={handleSort}
                                            sortServer
                                            persistTableHead
                                            progressPending={loading}
                                            customStyles={customStyles}
                                            noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}